export enum OrganizationFilterType {
    Provider = 3,
    Platform = 4,
}
